"use client"

import { Menu, X } from "lucide-react"

import { TrackedButton } from "@/components/analytics"

import { useMobileNavigation } from "./MobileNavigationProvider"

function HamburgerButton() {
  const { isMobileMenuOpen, setIsMobileMenuOpen } = useMobileNavigation()
  return (
    <TrackedButton
      action="Menu Toggled"
      aria-label="Toggle mobile menu"
      category="nav"
      className={
        "lg:hidden p-2 rounded-lg transition-colors text-body-muted hover:text-body"
      }
      label="Mobile Menu"
      onClick={() => {
        const nextOpen = !isMobileMenuOpen
        setIsMobileMenuOpen(nextOpen)
      }}
      value={!isMobileMenuOpen ? "Open" : "Close"}
    >
      {isMobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
    </TrackedButton>
  )
}

export default HamburgerButton
